import { render, staticRenderFns } from "./updatesaleorders.vue?vue&type=template&id=18ffa762"
import script from "./updatesaleorders.vue?vue&type=script&lang=js"
export * from "./updatesaleorders.vue?vue&type=script&lang=js"
import style0 from "./updatesaleorders.vue?vue&type=style&index=0&id=18ffa762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports